var lib_core     = require("lib-core");

var ModelUploadView = function(toggleButton, masterView, configuration){
    var self = this;

    this.toggleButton = toggleButton;
    this.configuration = configuration;

    if(masterView.model.wizardMode()) {
        if(this.toggleButton) {
            this.toggleButton.hide();
        }
    } else {
        if(this.toggleButton) {
            this.toggleButton.show();
        }
    }

    masterView.model.wizardMode.onChange(this, function(mode) {
        if(!mode) {
            if(self.toggleButton) {
                self.toggleButton.show();
            }
        }
    });
};

module.exports = ModelUploadView;